<template>
  <div class="nullable-score-input">
    <el-input
      v-if="showEmptyState"
      :value="''"
      :placeholder="placeholder"
      readonly
      @focus="activateEdit"
      @click.native="activateEdit"
    />
    <el-input-number
      v-else
      :value="draftValue"
      step-strictly
      controls-position="right"
      :min="min"
      :max="max"
      :placeholder="placeholder"
      @input="onInput"
      @change="onChange"
      @blur="onBlur"
    />
  </div>
</template>

<script>
export default {
  name: "NullableScoreInput",
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      editing: false,
      draftValue: 0,
    };
  },
  computed: {
    isEmpty() {
      return this.value === null || this.value === undefined || this.value === "";
    },
    showEmptyState() {
      return !this.editing && this.isEmpty;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        this.draftValue = this.normalizeValue(v);
      },
    },
  },
  methods: {
    normalizeValue(v) {
      const n = Number(v);
      if (!Number.isFinite(n)) return this.min;
      if (n < this.min) return this.min;
      if (n > this.max) return this.max;
      return n;
    },
    activateEdit() {
      this.editing = true;
      this.draftValue = this.normalizeValue(this.value);
      this.$nextTick(() => {
        const input = this.$el && this.$el.querySelector ? this.$el.querySelector("input") : null;
        if (input && typeof input.focus === "function") {
          input.focus();
          input.select && input.select();
        }
      });
    },
    onInput(v) {
      this.draftValue = this.normalizeValue(v);
      this.$emit("input", this.draftValue);
    },
    onChange(v) {
      this.draftValue = this.normalizeValue(v);
      this.$emit("input", this.draftValue);
    },
    onBlur() {
      this.editing = false;
    },
  },
};
</script>

<style scoped>
.nullable-score-input {
  width: 100%;
}

.nullable-score-input ::v-deep .el-input-number,
.nullable-score-input ::v-deep .el-input {
  width: 100%;
}
</style>
